import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useSupportCategory() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();
  function addCategory(data) {
    return privateFetch.post('/v1/admin/support/category', data);
  }

  function updateCategory({ categoryId, ...rest }) {
    return privateFetch.put(`/v1/admin/support/category/${categoryId}`, rest);
  }

  function manageCategory(data) {
    if (data.categoryId) return updateCategory(data);
    return addCategory(data);
  }

  return useMutation(manageCategory, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('support-category');
    },
  });
}

export default useSupportCategory;
